var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"loading-overlay",class:{ 'fade-out': _vm.isFading }},[_c('div',{staticClass:"loading-content"},[_c('img',{staticClass:"loading-icon",attrs:{"src":_vm.loadingImage,"alt":'Loading...'}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }